<template>
  <div
    class="test-method-matrix px-8 py-10 container"
    style="max-width: 1150px; margin: 0 auto;"
  >
    <div class="flex flex-wrap">
      <div class="w-full">
        <TitleComponent
          class="py-8"
          title="SSEC Method 2: In-Process"
          size="large"
        />

        <p class="text-xl font-bold mt-8">
          PAGE UNDER CONSTRUCTION
        </p>

        <p class="text-xl font-bold mt-8">
          Click to continue to the ETUG’s legacy
          <router-link to="/in-process-classification" style="color:#ef9a3d;">
            In-process Classification
          </router-link>
          (2015).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TitleComponent from "@/components/TitleComponent";

export default {
  components: {
    TitleComponent
  }
};
</script>

<style lang="scss"></style>
